var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layer",
    { staticClass: "opt_more_g", attrs: { name: "headCont" } },
    [
      _c(
        "div",
        { staticClass: "box_opt_menu head_cont_type" },
        _vm._l(_vm.headConts, function (headCont) {
          return _c("div", { staticClass: "menu_item" }, [
            _c(
              "a",
              {
                staticClass: "link_menu",
                attrs: { href: "javascript:" },
                on: {
                  click: function ($event) {
                    return _vm.callback(headCont)
                  },
                },
              },
              [_vm._v(_vm._s(headCont))]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }